import React, { useEffect, useState } from 'react';
import styles from './PageLevelTabs.module.scss';
import Tabs from 'components/Functional/Tabs';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { useRouter } from 'next/router';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

type FieldItem = {
  id: string;
  fields: {
    title: {
      value: string;
    };
  };
};

export type Props = ComponentProps & {
  fields: {
    items: FieldItem[];
  };
  anchorId?: string;
};

type QueryParams = {
  tab?: string;
};

const PageLevelTabs: React.FC<Props> = ({ fields, rendering, anchorId }) => {
  const router = useRouter();
  const { tab = '1' } = router.query as QueryParams;
  const [activeTab, setActiveTab] = useState<number | undefined>(undefined);
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor = sitecoreContext?.pageEditing;

  const toggleTab = (tab: number) => {
    setActiveTab(tab);
    router.push(
      { pathname: window.location.pathname, query: tab ? { tab: tab + 1 } : '' },
      undefined,
      {
        shallow: true,
      }
    );
  };

  useEffect(() => {
    if (router.isReady) {
      const tabIndex = Number.parseInt(tab) - 1;
      setActiveTab(tabIndex >= 0 && tabIndex < fields.items.length ? tabIndex : 0);
    }
  }, [fields.items.length, router.isReady, tab]);

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`page-level-section background-white ${styles.pageLevelTabs}`}
    >
      <div className="container">
        <Placeholder rendering={rendering} name="abrdn-tiles-heading" />
      </div>

      <Tabs
        className={styles.pageLevelTabsOverflow}
        activeTab={activeTab}
        fields={fields}
        onTabChange={toggleTab}
      />

      {isExperienceEditor
        ? fields.items.map((item, index) => (
            <Placeholder
              key={item.id}
              rendering={rendering}
              name={`abrdn-page-level-tab-${index}`}
            />
          ))
        : activeTab !== undefined && (
            <Placeholder rendering={rendering} name={`abrdn-page-level-tab-${activeTab}`} />
          )}
    </section>
  );
};

export default PageLevelTabs;
